import './not-found-page.scss';

function NotFoundPage() {
  return (
    <main className="not-found">
      <h1 className="not-found__title">404</h1>
      <p className="not-found__text">Страница не найдена</p>
    </main>
  );
}

export default NotFoundPage;
